//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'W-Button',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    role: {
      type: String,
      default: 'main' // ['main', '']

    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
};